import {camelizeKeys, decamelizeKeys} from 'humps'
import {fetcher, deleteHeaders, patchHeaders, postHeaders} from '~/api/fetcher'
import {replaceMoneyWithDineroObject} from '~/api/serializer'

export const createPayment = async ({
  supplierId,
  authenticityToken,
  params,
}) => {
  const body = decamelizeKeys(params, {deep: true})
  const opts = {
    ...postHeaders({authenticityToken, body}),
    rethrowAsAPINetworkError: false,
  }

  return fetcher(
    `/points_on_payments/api/suppliers/${supplierId}/payments`,
    opts,
  ).then((data) => {
    return camelizeKeys(data, {deep: true})
  })
}

export const createNewPayable = ({
  supplierId,
  authenticityToken,
  amountCents,
  payeeId,
  description,
}) => {
  const body = {
    payee_id: payeeId,
    amount: {
      cents: amountCents,
      currency: 'AUD',
    },
    description,
  }

  const opts = postHeaders({authenticityToken, body})

  return fetcher(
    `/points_on_payments/api/suppliers/${supplierId}/bills`,
    opts,
  ).then((data) => {
    const camelizedData = camelizeKeys(data, {deep: true})
    return replaceMoneyWithDineroObject(camelizedData)
  })
}

export const createPaymentMethodVerification = ({
  supplierId,
  paymentMethodId,
  authenticityToken,
  code,
}) => {
  const opts = postHeaders({authenticityToken, body: {verification: {code}}})

  return fetcher(
    `/points_on_payments/api/suppliers/${supplierId}/payment_methods/${paymentMethodId}/verifications`,
    opts,
  )
}

export const cancelPaymentMethod = ({
  supplierId,
  paymentMethodId,
  authenticityToken,
}) => {
  const opts = deleteHeaders({authenticityToken})

  return fetcher(
    `/points_on_payments/api/suppliers/${supplierId}/payment_methods/${paymentMethodId}`,
    opts,
  )
}

export const updatePayable = ({
  supplierId,
  authenticityToken,
  payableId,
  params,
}) => {
  const body = decamelizeKeys({payable: params}, {deep: true})
  const opts = {
    ...patchHeaders({authenticityToken, body}),
    rethrowAsAPINetworkError: false,
  }

  return fetcher(
    `/points_on_payments/api/suppliers/${supplierId}/bills/${payableId}`,
    opts,
  ).then((data) => {
    return camelizeKeys(data, {deep: true})
  })
}

export const verifyAbn = ({supplierId, authenticityToken, abn}) => {
  const opts = postHeaders({authenticityToken, body: {abn}, raiseClientErrors: false})
  return fetcher(
    `/points_on_payments/api/suppliers/${supplierId}/payees/verify_abn`,
    opts,
  ).then((data) => camelizeKeys(data, {deep: true}))
}

export const updatePayee = ({
  supplierId,
  payeeId,
  authenticityToken,
  values,
}) => {
  const body = {
    name: values.name,
    email: values.email,
    business_number: values.businessNumber,
    bank_account: {
      name: values.bankAccount.name,
      bsb: values.bankAccount.bsb,
      account_number: values.bankAccount.accountNumber,
    },
    lock_version: values.lockVersion,
  }
  const opts = patchHeaders({
    authenticityToken,
    body,
    raiseClientErrors: false,
  })

  return fetcher(
    `/points_on_payments/api/suppliers/${supplierId}/payees/${payeeId}`,
    opts,
  ).then((data) => {
    return camelizeKeys(data, {deep: true})
  })
}
